export const WATCH_BOARDS = 'WATCH_BOARDS';
export const UPDATE_BOARD = 'UPDATE_BOARD';
export const REMOVE_BOARD = 'REMOVE_BOARD';
